import axios from "axios";  // ✅ IMPORT NECESSARY

// ✅ Sirf .env se URL lega
const API_BASE_URL = process.env.REACT_APP_API_URL;
const BASE_URL = `${API_BASE_URL}Rating`;

// ✅ Image URL bhi same domain se lega
const IMAGE_BASE_URL = API_BASE_URL?.replace('/api/', '/BannerImage/');

export const getAllBanners = async (categoryId) => {
  try {
    const response = await axios.get(`${BASE_URL}/GetAllBanner`);
    
    // ✅ API response direct array de raha hai
    const banners = response.data;
    
    console.log("📦 ALL BANNERS:", banners);
    console.log("🎯 CATEGORY ID:", categoryId);
    
    const filteredBanners = banners
      .filter((item) => Number(item.bannerCategoryId) === Number(categoryId))
      .map((item) => ({
        ...item,
        imageUrl: `${IMAGE_BASE_URL}${item.image}`,
      }));
    
    console.log("✅ FILTERED BANNERS:", filteredBanners);
    
    return filteredBanners;
  } catch (error) {
    console.error("Banner API Error:", error);
    return [];
  }
};